export default __webpack_public_path__ + "static/media/Hydrological_Modeling.28bc32bb.webp";